var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Modal from '@/components/Modal.vue';
import { Component, Emit, Vue, PropSync } from 'vue-property-decorator';
let AccessTokenModal = class AccessTokenModal extends Vue {
    constructor() {
        super(...arguments);
        this.token = '';
    }
    mounted() {
        this.token = '';
    }
    onTryToLogin() {
        this.tryToLogin(this.token);
    }
    tryToLogin(token) { }
};
__decorate([
    PropSync('open', { default: false })
], AccessTokenModal.prototype, "showAccessTokenModal", void 0);
__decorate([
    Emit('tryToLogin')
], AccessTokenModal.prototype, "tryToLogin", null);
AccessTokenModal = __decorate([
    Component({
        name: 'ReactivationTokenModal',
        components: {
            Modal,
        },
    })
], AccessTokenModal);
export default AccessTokenModal;
